// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagina-contenedores.contenedorprincipal {
  width: 95%;
  margin: 0 auto;
  padding-bottom: 5px;
  display: flex;
  flex-direction: column;
}

.pagina-contenedores .titulo {
  text-align: center;
  margin-top: 0px;
  margin-bottom: 2px;
}

.pagina-contenedores .botonessuperiores {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  flex-wrap: wrap;
}

.botonessuperiores .p-button {
  margin: 0 !important;
  padding: 8px 16px;
  font-size: 14px;
}

/* [EXPERT] Forzar layout automático para este módulo con muchas columnas */
.pagina-contenedores .p-datatable .p-datatable-wrapper table {
  table-layout: auto !important;
  min-width: 100%;
}

/* [EXPERT] Estabilidad del paginador y alineación */
.pagina-contenedores .p-datatable .p-datatable-wrapper {
  min-height: 400px;
}

.pagina-contenedores .p-datatable .p-datatable-thead > tr > th {
  text-align: center !important;
  vertical-align: middle !important;
  padding: 0.35rem !important;
}

.pagina-contenedores .p-datatable .p-datatable-tbody > tr > td {
  text-align: center !important;
  vertical-align: middle !important;
  padding: 0.3rem !important;
  height: 38px !important;
}

/* ============================================
   MEDIA QUERIES - RESPONSIVIDAD
   ============================================ */

/* === TABLETS Y LAPTOPS PEQUEÑAS (1024px y menores) === */
@media (max-width: 1024px) {
  .pagina-contenedores.contenedorprincipal {
    width: 98%;
  }

  .pagina-contenedores .botonessuperiores {
    flex-wrap: wrap;
  }

  .pagina-contenedores .p-datatable .p-datatable-thead > tr > th {
    font-size: 0.8rem;
    padding: 0.25rem !important;
  }

  .pagina-contenedores .p-datatable .p-datatable-tbody > tr > td {
    font-size: 0.85rem;
    padding: 0.25rem !important;
    height: 36px !important;
  }
}

/* === TABLETS (768px y menores) === */
@media (max-width: 768px) {
  .pagina-contenedores.contenedorprincipal {
    width: 100%;
    padding: 5px;
  }

  .pagina-contenedores .titulo {
    font-size: 1.2rem;
    margin-bottom: 8px;
  }

  .pagina-contenedores .botonessuperiores {
    flex-direction: column;
    gap: 8px;
  }

  .pagina-contenedores .botonessuperiores .p-button {
    width: 100%;
    justify-content: center;
  }

  .pagina-contenedores .p-datatable-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    min-height: 350px;
  }

  /* Indicador visual de scroll */
  .pagina-contenedores .p-datatable-wrapper::after {
    content: "← Desliza para ver más →";
    display: block;
    text-align: center;
    padding: 6px;
    background: #fff3cd;
    font-size: 0.8rem;
    color: #856404;
    border-top: 1px solid #ffeaa7;
  }
}

/* === MÓVILES PEQUEÑOS (480px y menores) === */
@media (max-width: 480px) {
  .pagina-contenedores .titulo {
    font-size: 1rem;
  }

  .pagina-contenedores .p-datatable .p-datatable-thead > tr > th {
    font-size: 0.75rem;
    padding: 0.2rem !important;
  }

  .pagina-contenedores .p-datatable .p-datatable-tbody > tr > td {
    font-size: 0.75rem;
    padding: 0.2rem !important;
    height: 32px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/ListaContenedores.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;AACjB;;AAEA,2EAA2E;AAC3E;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA,oDAAoD;AACpD;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;;iDAEiD;;AAEjD,0DAA0D;AAC1D;EACE;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,2BAA2B;IAC3B,uBAAuB;EACzB;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;IACjC,iBAAiB;EACnB;;EAEA,+BAA+B;EAC/B;IACE,mCAAmC;IACnC,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,6BAA6B;EAC/B;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;EACzB;AACF","sourcesContent":[".pagina-contenedores.contenedorprincipal {\n  width: 95%;\n  margin: 0 auto;\n  padding-bottom: 5px;\n  display: flex;\n  flex-direction: column;\n}\n\n.pagina-contenedores .titulo {\n  text-align: center;\n  margin-top: 0px;\n  margin-bottom: 2px;\n}\n\n.pagina-contenedores .botonessuperiores {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 15px;\n  flex-wrap: wrap;\n}\n\n.botonessuperiores .p-button {\n  margin: 0 !important;\n  padding: 8px 16px;\n  font-size: 14px;\n}\n\n/* [EXPERT] Forzar layout automático para este módulo con muchas columnas */\n.pagina-contenedores .p-datatable .p-datatable-wrapper table {\n  table-layout: auto !important;\n  min-width: 100%;\n}\n\n/* [EXPERT] Estabilidad del paginador y alineación */\n.pagina-contenedores .p-datatable .p-datatable-wrapper {\n  min-height: 400px;\n}\n\n.pagina-contenedores .p-datatable .p-datatable-thead > tr > th {\n  text-align: center !important;\n  vertical-align: middle !important;\n  padding: 0.35rem !important;\n}\n\n.pagina-contenedores .p-datatable .p-datatable-tbody > tr > td {\n  text-align: center !important;\n  vertical-align: middle !important;\n  padding: 0.3rem !important;\n  height: 38px !important;\n}\n\n/* ============================================\n   MEDIA QUERIES - RESPONSIVIDAD\n   ============================================ */\n\n/* === TABLETS Y LAPTOPS PEQUEÑAS (1024px y menores) === */\n@media (max-width: 1024px) {\n  .pagina-contenedores.contenedorprincipal {\n    width: 98%;\n  }\n\n  .pagina-contenedores .botonessuperiores {\n    flex-wrap: wrap;\n  }\n\n  .pagina-contenedores .p-datatable .p-datatable-thead > tr > th {\n    font-size: 0.8rem;\n    padding: 0.25rem !important;\n  }\n\n  .pagina-contenedores .p-datatable .p-datatable-tbody > tr > td {\n    font-size: 0.85rem;\n    padding: 0.25rem !important;\n    height: 36px !important;\n  }\n}\n\n/* === TABLETS (768px y menores) === */\n@media (max-width: 768px) {\n  .pagina-contenedores.contenedorprincipal {\n    width: 100%;\n    padding: 5px;\n  }\n\n  .pagina-contenedores .titulo {\n    font-size: 1.2rem;\n    margin-bottom: 8px;\n  }\n\n  .pagina-contenedores .botonessuperiores {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .pagina-contenedores .botonessuperiores .p-button {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .pagina-contenedores .p-datatable-wrapper {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    min-height: 350px;\n  }\n\n  /* Indicador visual de scroll */\n  .pagina-contenedores .p-datatable-wrapper::after {\n    content: \"← Desliza para ver más →\";\n    display: block;\n    text-align: center;\n    padding: 6px;\n    background: #fff3cd;\n    font-size: 0.8rem;\n    color: #856404;\n    border-top: 1px solid #ffeaa7;\n  }\n}\n\n/* === MÓVILES PEQUEÑOS (480px y menores) === */\n@media (max-width: 480px) {\n  .pagina-contenedores .titulo {\n    font-size: 1rem;\n  }\n\n  .pagina-contenedores .p-datatable .p-datatable-thead > tr > th {\n    font-size: 0.75rem;\n    padding: 0.2rem !important;\n  }\n\n  .pagina-contenedores .p-datatable .p-datatable-tbody > tr > td {\n    font-size: 0.75rem;\n    padding: 0.2rem !important;\n    height: 32px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
